import { trimStart } from 'lodash';
import { BLOG_APP_ID, MEMBERS_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import {
  BLOG_PAGE_ID,
  BLOG_POST_PAGE_ID,
  MEMBERS_PAGE_ID,
} from '@wix/communities-blog-client-common/dist/src/constants/component-ids';
import Wix from './wix-sdk-polyfill';
import { debug } from './debug';

const navigateInsideBlog = sectionId => location =>
  Wix.Utils.navigateToSection(
    {
      appDefinitionId: BLOG_APP_ID,
      sectionId,
      shouldRefreshIframe: false,
    },
    trimStart(location, '/'),
    debug.error,
  );

export const navigateToBlog = navigateInsideBlog(BLOG_PAGE_ID);
export const navigateToPostPage = navigateInsideBlog(BLOG_POST_PAGE_ID);
export const navigateToBlogOrPostPage = (location, isPostPageEnabled) =>
  isPostPageEnabled && location !== '' ? navigateToPostPage(location) : navigateToBlog(location);

export const navigateToMembers = location =>
  Wix.Utils.navigateToSection(
    {
      appDefinitionId: MEMBERS_APP_ID,
      sectionId: MEMBERS_PAGE_ID,
      shouldRefreshIframe: false,
    },
    trimStart(location, '/'),
    debug.error,
  );

export const navigate = (to, isMembersRoute) => {
  isMembersRoute ? navigateToMembers(to) : navigateToBlog(to);
};

export const navigateWithPostMessage = sectionId => to => {
  Wix.getComponentInfo(info => {
    const url = to.indexOf('/') === 0 ? to.substring(1) : to;
    const msg = {
      intent: 'TPA2',
      type: 'navigateToSectionPage',
      compId: info.compId,
      data: {
        ignorePageUriSeo: true,
        sectionIdentifier: {
          appDefinitionId: BLOG_APP_ID,
          sectionId: sectionId,
          shouldRefreshIframe: false,
        },
        state: url,
      },
    };
    window.parent.postMessage(JSON.stringify(msg), '*');
  });
};

export const navigateToBlogWithPostMessage = navigateWithPostMessage(BLOG_PAGE_ID);
